export interface StoryblokImageDimensions {
	width: number | undefined;
	height: number | undefined;
}

/** Easiest way to get a SB image's dimensions from its URL. Alternatively, we could use `resolve_assets=1` in the story fetch request. */
export default function sbImageDimensions(
	url: string | null | undefined,
): StoryblokImageDimensions {
	const [, width, height] = url?.match(/\/(\d+)x(\d+)\//) ?? [];
	if (width === undefined || height === undefined) {
		return {
			width: undefined,
			height: undefined,
		};
	}
	return {
		width: Number(width),
		height: Number(height),
	};
}
